import React, { useState } from 'react';
import { Button, Modal, Spin, Row, Upload } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { CloseOutlined } from '@ant-design/icons';
import { useAppDispatch } from 'app/config/store';
import { uploadFactureEleveList as uploadFactureList } from '../factures/facture.reducer';

const FileUploadHandler = ({ ecoleId, scolariteId }: { ecoleId: string; scolariteId: string }) => {
  const dispatch = useAppDispatch();
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);

  const prop = {
    onRemove() {
      setFile(null);
      setIsUploading(false);
    },
    beforeUpload(fil) {
      setFile(fil);
      return false;
    },
    file,
  };

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleUpload = () => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    const entity = {
      ecoleId,
      scolariteId,
      file: formData,
    };
    setIsUploading(true);

    dispatch(uploadFactureList(entity))
      .then(() => {
        setIsUploading(false);
        setFile(null);
        closeModal();
      })
      .catch(() => {
        setIsUploading(false);
      });
  };

  return (
    <div>
      <Button
        onClick={openModal}
        disabled={isUploading}
        type="primary"
        style={{
          backgroundColor: isUploading ? '#ccc' : '',
          border: `1px solid ${isUploading ? '#ccc' : ''}`,
        }}
      >
        {isUploading ? <Spin /> : <FontAwesomeIcon icon={faRedoAlt} />}
        &nbsp; Mettre à jour les factures
      </Button>

      <Modal
        visible={modalVisible}
        title="Importer la liste des élèves à mettre à jour par Espèce/Chèque"
        onCancel={closeModal}
        footer={null}
        width="50%"
        closable={true}
        closeIcon={<CloseOutlined style={{ color: '#F28E19' }} />}
        centered
      >
        <div>
          <Row justify="end" align="middle" style={{ marginBottom: '20px' }}>
            <Upload {...prop}>
              <Button
                type="dashed"
                icon={<FontAwesomeIcon className="mx-1" icon={faDownload} />}
                className="jh-create-entity"
                id="jh-create-entity"
              >
                Importer
              </Button>
            </Upload>
          </Row>

          <Row justify="start">
            <Button
              style={{ color: file && 'whitesmoke' }}
              className={`mt-2 mx-1 ${file && 'bg-success'}`}
              onClick={handleUpload}
              disabled={!file || isUploading}
              loading={isUploading}
            >
              {isUploading ? 'Création...' : 'Mettre à jour les factures'}
            </Button>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default FileUploadHandler;
